import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const scrollPositions = {};

export default function ScrollToTop() {
    const location = useLocation();
    const navType = useNavigationType();
    const prevPath = useRef(location.pathname);

    useEffect(() => {
        // Save scroll position of previous page
        scrollPositions[prevPath.current] = window.scrollY;

        if (navType === "PUSH") {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }

        if (navType === "POP") {
            const y = scrollPositions[location.pathname] || 0;
            window.scrollTo({ top: y });
        }

        prevPath.current = location.pathname;
    }, [location.pathname, navType]);

    const getAnimationClass = () => {
        if (navType === "PUSH") return "slide-in-right";
        if (navType === "POP") return "slide-in-left";
        return "";
    };

    return null
}